var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[(_vm.isAdmin)?_c('v-col',{attrs:{"cols":"auto"}},[_c('group-list')],1):_vm._e(),_c('v-col',{attrs:{"cols":"auto"}},[_c('user-list')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }